import { render, staticRenderFns } from "./RegisterSignUp.vue?vue&type=template&id=c2c0d8f4&scoped=true"
import script from "./RegisterSignUp.vue?vue&type=script&lang=js"
export * from "./RegisterSignUp.vue?vue&type=script&lang=js"
import style0 from "./RegisterSignUp.vue?vue&type=style&index=0&id=c2c0d8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c0d8f4",
  null
  
)

export default component.exports